import { CircularProgress } from '@mui/material';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PolicyIcon from '@mui/icons-material/Policy';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const GetTcolumns = (props) => {
  const result = <tr>
    <th width="5%" scope="col">{ props.openGlobalLoader ? <CircularProgress size={'1rem'} /> : '#' }</th>
    <th width="70%" scope="col">Role</th>
    <th width="10%" scope="col">Active</th>
    <td width="15%" align="right"><strong style={{ marginRight: '12%' }}>Action</strong></td>
  </tr>

  return result;
}

export const GetTsearch = (props) => {
  const result = <tr>
    <td></td>
    <td>
      <TextField
        onKeyPress={ (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              props.onSearchInputEnterKey();
            }
          }
        }
        label="Role"
        size="small"
        name="roleName"
        value={props.roleName}
        onChange={props.handleInputChange}
      />
    </td>
    <td>
      <Select
        fullWidth
        label="Active"
        size="small"
        name="active"
        variant="standard"
        margin="dense"
        value={props.active}
        onChange={props.handleInputChange}
      >
        <MenuItem key={'empty'} value={''}>-- SELECT --</MenuItem>
        <MenuItem key={'1'} value={'1'}>YES</MenuItem>
        <MenuItem key={'0'} value={'0'}>NO</MenuItem>
      </Select>
    </td>
    <td align="right">
      <button type="button" className="btn btn-link" onClick={props.resetTableSearchInput}>Clear Filters</button>
    </td>
  </tr>

  return result;
}

const ListItem = (props) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    row,
    rowIndex
  } = props
  return (
      <tr>
      <td>{rowIndex}</td>
      <td>{ row.roleName }</td>
      <td>{ row.active ? 'YES' : 'NO' }</td>
      <td align="right">

        { row.id !==3 && <><Button
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Action
      </Button>
      <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
        <MenuItem onClick={(e) => { handleClose(); props.setOpen(true, row.id, row.roleName, 'VIEW'); }} disableRipple>
          <VisibilityIcon />
          View
        </MenuItem><MenuItem onClick={(e) => { handleClose(); props.setOpen(true, row.id, row.roleName, 'EDIT'); }} disableRipple>
          <EditIcon />
          Edit
        </MenuItem><MenuItem onClick={(e) => { handleClose(); props.setOpen(true, row.id, row.roleName, 'DELETE'); }} disableRipple>
          { props.deleted ? <><RestoreFromTrashIcon />Restore</> : <><DeleteIcon />Delete</> }
        </MenuItem><Divider sx={{ my: 0.5 }} />
      <MenuItem onClick={(e) => { handleClose(); props.setOpen(true, row.id, row.roleName, 'ROLE-MODULE'); }} disableRipple>
          <PolicyIcon />
          Manage permission
        </MenuItem>
      </Menu></> }

      </td>

    </tr>
  );
}

export const GetTvalues = (props) => {
  let rowIndex = props.t_index;
  const result = props.t_data.map((row) =>
    <ListItem
      rowIndex={++rowIndex}
      key={row.id}
      row={row}
      setOpen={props.setOpen}
      deleted={props.deleted}
    />
  )

  return result;
}
